module.exports = __webpack_public_path__ + "img/nongMin2.7f9af31d.png";